<template>
  <div>
    <base-pie-chart
      v-show="!printable || (!imgData && printable)"
      :height="height ? height : null"
      :chart-data="getChartData"
      :options="getChartOptions"
      @chartCreated="setChart"
    />
    <img :height="height ? height : 200" :src="imgData" v-show="printable && imgData">
  </div>
</template>

<script>
import chartMixin from './mixins/chartMixin';

import BasePieChart from './base/BasePieChart';

export default {
  name: 'PieChart',
  components: {
    BasePieChart,
  },
  data: () => ({
    chart: null,
    imgData: null,
  }),
  props: {
    height: {
      type: Number,
    },
    printable: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [chartMixin],
  methods: {
    setChart(chart) {
      this.chart = chart;
    },
    animationComplete() {
      if (!this.chart || !this.printable) {
        return;
      }
      this.imgData = this.chart.toBase64Image();
    },
  },
};
</script>



// WEBPACK FOOTER //
// PieChart.vue?2d061e46